import React, { useState, useEffect } from "react";
import MainContainer from "../../components/app/maincontainer";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { NewInput, SelectInput } from "../../components/inputs/main";
import PrimaryBtn, { MainBtn } from "../../components/app/buttons";
import DoneModal from "../../components/modals/donemodal";
import useErrorStore from "../../data/stores/errorStore";
import { toast } from "react-toastify";
import { apiCall } from "../../data/useFetcher";
import { toCamel } from "../../data/useExtractor";
import Upload from "../../assets/icons/upload.svg";
import RawSample from "../../assets/User Invite Sample.xlsx";
import { IoIosAdd } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { AddUsersModal } from "../../components/modals/addtoolsmodal";

const AddUser = () => {
	const location = useLocation()?.state,
		[modal, setModal] = useState(""),
		navigate = useNavigate(),
		[pres, setPres] = useState<any>(null),
		toggleUploadModal = () => {
			setPres(null);
			setModal("");
		},
		init2: {
			firstName?: string;
			lastName?: string;
			email?: string;
			privilege?: string;
		} = {},
		[itemForm, setItemForm] = useState([init2]),
		[loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore(),
		handleSubmit = async () => {
			// e?.preventDefault();
			if (itemForm?.length === 0) return toast.info("Invitee required");
			for (let f = 0; f < itemForm.length; f++) {
				const { firstName, lastName, email } = itemForm[f];

				if (!email || !lastName || !firstName)
					return toast.info(`S/N ${f + 1} User details is required`);
			}

			setLoading(true);
			let { response, errArr, errMsg } = await apiCall({
				type: "post",
				url: `/api/v1/user/team-members`,
				data: {
					members: itemForm,
					nextScreen: `${window.location.origin}/activate`,
				},
			});
			console?.log({ response, errArr, errMsg });
			if (errArr) {
				setLoading(false);
				return returnErrors(errArr);
			}
			if (errMsg) {
				setLoading(false);
				return toast.error(errMsg);
			}
			setLoading(false);
			if (response) {
				navigate(-1);
				return;
			}
			setLoading(false);
		};

	const onSubmit2 = async () => {
		// console.log({ data });
		if (pres?.length === 0 && location?.length === 0)
			return toast.info("Bulk Upload' details required");
		try {
			let newItemForm = location || pres;
			let newPres = [];
			for (let p = 0; p < newItemForm?.length; p++) {
				const element = newItemForm?.[p];
				newPres?.push(toCamel(element));
			}
			let newItem = [];
			for (let n = 0; n < newPres?.length; n++) {
				const element = newPres?.[n];
				newItem = [...newItem, { ...element, privilege: element?.role }];
			}
			setItemForm(!location ? [...itemForm, ...newItem] : newItem);
			console.log({ newItem });
			toggleUploadModal();
			// navigate(`?step=${route}`);
		} catch (err) {
			if (err) console.log({ error: err.response?.data, err });
		}
	};

	useEffect(() => {
		if (location || pres) onSubmit2();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, pres]);

	const handleInputChangeForMutipleItem = (
		event:
			| React.ChangeEvent<HTMLInputElement>
			| React.ChangeEvent<HTMLSelectElement>,
		index: number,
		field: string
	) => {
		const { value } = event.target;
		let itemValue = value;

		setItemForm(prevRows => {
			const newRows = [...prevRows];
			newRows[index][field] = itemValue;
			return newRows;
		});
	};

	const handleDeleteRowForMutipleItem = (index: number) => {
		setItemForm(prevRows => {
			const newRows = [...prevRows];
			newRows.splice(index, 1);
			return newRows;
		});
	};

	const addRowForMutipleItem = () => {
		const newRow = {};
		setItemForm([...itemForm, newRow]);
	};

	return (
		<div>
			<MainContainer>
				<div className="mt-8 flex justify-between items-center">
					<div className="flex gap-2">
						<FaChevronLeft
							color="#334155"
							onClick={() => navigate(-1)}
							className="cursor-pointer mt-1"
						/>
						<div>
							<h1 className="text-xl font-semibold text-da-blue-600 inter">
								Add User
							</h1>
							<div className="flex gap-2 items-center">
								<span className="text-base font-normal text-[#334155]">
									User List
								</span>
								<FaChevronRight color="#334155" size={10} />
								<span className="text-base font-normal text-[#334155]">
									Add User
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="mt-12 bg-white min-h-screen w-full p-8">
					<div
						style={{
							borderBottom: "1px solid #E2E8F0",
						}}
						className="h-full w-full pb-3 flex justify-between">
						<h4 className="text-xl font-semibold inter text-da-blue-600">
							User Data
						</h4>
						<PrimaryBtn
							color={"#3787FF"}
							onClick={() => setModal("add")}
							icon={Upload}
							text={"Bulk Upload"}
							bg={"transparent"}
							className="border border-da-blue-100"
						/>
					</div>
					<form className="mt-6" onSubmit={handleSubmit}>
						{itemForm?.map((item, index) => (
							<>
								<div className="relative grid grid-cols-2 lg:grid-cols-4  w-4/5 gap-5">
									<div>
										<NewInput
											onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
												handleInputChangeForMutipleItem(e, index, "firstName")
											}
											value={item.firstName}
											label={index === 0 ? "First Name" : ""}
											placeholder={"John"}
										/>
									</div>
									<div className="">
										<NewInput
											label={index === 0 ? "Last Name" : ""}
											placeholder="Doe"
											onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
												handleInputChangeForMutipleItem(e, index, "lastName")
											}
											value={item.lastName}
										/>
									</div>
									<div className="">
										<NewInput
											label={index === 0 ? "Email" : ""}
											placeholder="johdoe@mail.com"
											onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
												handleInputChangeForMutipleItem(e, index, "email")
											}
											value={item.email}
										/>
									</div>
									<div className="">
										<SelectInput
											label={index === 0 ? "Role" : ""}
											onChange2={(e: React.ChangeEvent<HTMLSelectElement>) =>
												handleInputChangeForMutipleItem(e, index, "privilege")
											}
											value={item.privilege}
											options={[
												{ _id: "superadmin", title: "Superadmin" },
												{ _id: "admin", title: "Admin" },
												{ _id: "user", title: "User" },
											]}
										/>
									</div>
									<div
										onClick={() => handleDeleteRowForMutipleItem(index)}
										className="md:absolute self-center -right-20 cursor-pointer">
										<p className="text-sm text-red-600 flex items-center md:mt-2 gap-2">
											<span>
												<MdDelete />
											</span>
											Remove
										</p>
									</div>
								</div>
							</>
						))}
						<p
							onClick={addRowForMutipleItem}
							className="flex items-center gap-2 text-bluerolodex f-medium my-3 cursor-pointer">
							<span>
								<IoIosAdd />
							</span>
							Add user
						</p>
						<div className="flex mt-9 gap-5">
							<MainBtn
								onClick={() => navigate(-1)}
								className="border border-[#FECACA]"
								text={"Discard"}
								bg={"transparent"}
								color={"#EF4444"}
								type="button"
								disabled={loading}
							/>
							<MainBtn
								text={"Continue"}
								bg={"#3787FF"}
								color={"white"}
								loading={loading}
								type="button"
								onClick={() => handleSubmit()}
							/>
						</div>
					</form>
				</div>
				{modal === "done" && (
					<DoneModal page={"User"} handleClose={() => setModal("")} />
				)}
				{modal === "add" && (
					<AddUsersModal
						handleClose={toggleUploadModal}
						handleImport={pres2 => {
							setPres(pres2);
						}}
						sample={RawSample}
					/>
				)}
			</MainContainer>
		</div>
	);
};

export default AddUser;
